
import Logo from "../../../helper/svg/LOGO.svg";
import Spoons from "../../../helper/svg/spoons.svg";
import Hotels from "../../../helper/svg/hotel.svg";
import Mobile from "../../../helper/svg/mobile.svg";
import { Link, useNavigate } from "react-router-dom";
import { verifyOTP, resendOTP } from "../../../api/auth";

import React, { useState, useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";


const OtpVerification = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const mobile = searchParams.get("mobile")
  const navigate = useNavigate()

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;

    setOtp(updatedOtp);

    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }

    if (!value && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) prevInput.focus();
    }

    if (updatedOtp.join("").length === 6) {
      handleVerify(updatedOtp);
    }
  };





  const verifyOtpMutation = useMutation({
    mutationFn: (data) => verifyOTP(data),
    onSuccess: () => {
      toast.success("Account verified successfully.");
       navigate("/login")
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "OTP verification failed");
    },
  });

  const resendOtpMutation = useMutation({
    mutationFn: (data) => resendOTP(data),
    onSuccess: () => {
      toast.success("OTP resent successfully.");
      setTimer(60);
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to resend OTP");
    },
  });

  const handleVerify = (updatedOTP) => {
    let code = ""
    if (updatedOTP.length>0) {
      code = updatedOTP.join("")
    } else {
      code = otp.join("");
    }

    if (!email) {
      toast.error("Email is missing")
      return false;
    }
    if (code.length < 6) {
      toast.error("Enter a valid 6-digit OTP");
      return;
    }
    verifyOtpMutation.mutate({ email, code });
  };

  const handleResend = () => {
    if (timer > 0) return;
    if (!email) {
      toast.error("Email is missing.");
      return;
    }
    resendOtpMutation.mutate({ email });
  };

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 h-screen">
      {/*  =============== left side =============== */}
      <div className="bg-[#FFF3EF] flex items-center lg:justify-start justify-center">
        <div className="w-full max-w-[650px] lg:ml-auto xl:pr-[175px] lg:pr-[100px]  md:py-[20px] py-[30px] px-[15px]">
          <Link to="/">
            <img src={Logo} alt="logo" className="w-[133px]" />
          </Link>
          <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
            <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
              <img src={Spoons} alt="Icon" className="w-[37px]" />
            </div>
            <div className="w-full">
              <h2 className="md:text-[22px] text-lg  font-semibold leading-[22px] mb-[7px]">
                Smart Table Management
              </h2>
              <p className="text-base leading-[26px]">
                Automate reservations, manage waitlists, and optimize seating
                effortlessly.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
            <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
              <img src={Hotels} alt="Icon" className="w-[37px]" />
            </div>
            <div className="w-full">
              <h2 className="md:text-[22px] text-lg  font-semibold leading-[22px] mb-[7px]">
                Hassle-Free Hotel Booking
              </h2>
              <p className="text-base leading-[26px]">
                Streamline room reservations, real-time availability, and smooth
                check-ins.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
            <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
              <img src={Mobile} alt="Icon" className="w-[37px]" />
            </div>
            <div className="w-full">
              <h2 className="md:text-[22px] text-lg font-semibold leading-[22px] mb-[7px]">
                Effortless Operations
              </h2>
              <p className="text-base leading-[26px]">
                Enhance efficiency with automation for a flawless guest
                experience.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/*  =============== Right side =============== */}
      <div className="flex items-center lg:justify-start justify-center lg:pl-[72px]  md:pl-[20px] md:py-[20px] py-[30px] px-[15px] w-full max-w-[100%]">
        <div className="w-full  max-w-[586px]  ">
          <form onSubmit={(e) => e.preventDefault()} className="w-full md:py-[40px] md:px-[27px] py-[25px] px-[15px] rounded-[10px] form-shadow">
            <h2 className="md:text-[30px] text-[22px] font-medium text-center leading-[40px] placeholder:text-[#858585]">
              Verify code
            </h2>
            <p className="text-center w-full max-w-[380px] text-lg leading-[30px] mx-auto mt-[9px] md:mb-[30px] mb-4">
              Please enter the code we have just sent on{" "}
              <Link className="text-[#FFA808]">{mobile}*****</Link>
            </p>
            <div className="flex justify-center items-center md:gap-[22px] gap-2">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  className="md:w-[68px] md:h-[57px] w-[40px] h-[40px] md:rounded-[15px] rounded-lg  outline-none border border-[#ECEBEB] text-[18px] placeholder:text-[#858585] text-center"
                />
              ))}

            </div>
            <p className="text-center text-[18px] text-[#2E2E2E] md:mt-[30px] mt-[20px] flex flex-col gap-[10px]">
              Don’t receive OTP?

              <button
                type="button"
                className={`text-[#FFA808] underline ${timer > 0 ? "cursor-not-allowed opacity-50" : ""}`}
                onClick={handleResend}
                disabled={timer > 0}
              >
                Resend Code {timer > 0 ? `(${timer}s)` : ""}
              </button>
            </p>
            <button
              onClick={handleVerify}
              className="w-full rounded-[2px] bg-[#4CAF50] text-[18px] text-white font-semibold p-[19px] green-shadow hover:bg-[#209b25] md:mt-[45px] mt-[20px]"
            >
              Verify
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};




export default OtpVerification;
